import { INPUT_DEBOUNCE_TIME } from '../../constants/common.constants';

const debounce = <T, >(func: (...args: T[]) => void, wait: number, onCancel?: () => void) => {
    let timeout: ReturnType<typeof setTimeout> | null = null;

    return (...args: T[]) => {
        if (timeout !== null) {
            onCancel?.();
            clearTimeout(timeout);
        }

        timeout = setTimeout(() => {
            func(...args);
            timeout = null;
        }, wait);
    };
};

/* Method Decorator to debounce method execution */
const debounceExecution = (delay: number = INPUT_DEBOUNCE_TIME) =>
    (target: object, propertyKey: string, descriptor: PropertyDescriptor) => {
        const originalMethod = descriptor.value;
        let timeout;

        descriptor.value = function _debounceExecution(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => originalMethod.apply(this, args), delay);
        };

        return descriptor;
    }
;


export { debounce, debounceExecution };
